export default "__VITE_ASSET__a796dbad__"